import {useLazyQuery, useQuery} from '@apollo/client';
import {useParams} from 'react-router-dom';
import {useEffect} from 'react';
import {LIST_OV_BUILDER} from '../BuilderGrid/builderOvPotQueries';
import {
  OVBuilders as OVRecommends,
  OVBuildersVariables as OVRecommendsVariables,
} from '../../../schema-types/OVBuilders';
import {useAccountContext} from '../../../contexts/AccountContext';
import validateUUID from '../../../utils/validateUUID';

export const useAccountOVBuilds = () => {
  const {accountId} = useAccountContext();
  const {data, error, loading} = useQuery<OVRecommends, OVRecommendsVariables>(
    LIST_OV_BUILDER,
    {
      variables: {
        entityName: 'account',
        entityId: validateUUID(accountId),
      },
      fetchPolicy: 'network-only',
      skip: !accountId,
    }
  );

  return {data, error, loading};
};

export const useReviewOVBuilds = () => {
  const {reviewId} = useParams();
  const [onFetch, {data, error, loading}] = useLazyQuery<
    OVRecommends,
    OVRecommendsVariables
  >(LIST_OV_BUILDER, {
    variables: {
      entityName: 'review',
      entityId: validateUUID(reviewId),
    },
    fetchPolicy: 'network-only',
  });
  useEffect(() => {
    let clear: NodeJS.Timeout | null;
    if (reviewId) {
      clear = setTimeout(() => {
        onFetch({
          variables: {
            entityName: 'review',
            entityId: validateUUID(reviewId),
          },
        });
      }, 10000);
    }
    return () => {
      if (clear) {
        clearTimeout(clear);
      }
    };
  }, [reviewId]);

  return {data, error, loading};
};

export const useOVBuilds = (isAccount = false) => {
  const {reviewId} = useParams();
  const {accountId} = useAccountContext();
  const {data, error, loading} = useQuery<OVRecommends, OVRecommendsVariables>(
    LIST_OV_BUILDER,
    {
      variables: {
        entityName: isAccount ? 'account' : 'review',
        entityId: isAccount ? validateUUID(accountId) : validateUUID(reviewId),
      },
      skip: isAccount ? !accountId : !reviewId,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'network-only',
    }
  );
  return {data, error, loading};
};
